export var ActionTypeModel;
(function (ActionTypeModel) {
  ActionTypeModel["ACCEPT_MEMBERSHIP_BANNER_ACTION"] = "ACCEPT_MEMBERSHIP_BANNER_ACTION";
  ActionTypeModel["RELOAD_PAGE_BANNER_ACTION"] = "RELOAD_PAGE_BANNER_ACTION";
  ActionTypeModel["CLOSE_BANNER"] = "CLOSE_BANNER";
})(ActionTypeModel || (ActionTypeModel = {}));
